var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var slugify = require('../utils/slugify.js');

function Report(el) {
  var $el = $(el),
      $subnav = $el.find('#report-subnav');

  if ($el.find('h2').length > 0) {
    $el.find('h2').each(function() {
      var subhead = $(this).text(),
          subheadSlug = slugify(subhead);
      $(this).html('<a name="' + subheadSlug + '">' + subhead + '</a>');
      $subnav.append('<li><a href="#' + subheadSlug + '">' + subhead + '</a></li>');
    });
  } else {
    $subnav.hide();
  }

}

module.exports = Report;
